module.exports = __webpack_public_path__ + "img/img47.ab8b96ef.svg";